import { ErrorBoundary, VStack } from '@genial/components';
import React from 'react';

import {
  fixedFeeTermsEmptyState,
  fixedFeeTermsNoRequestsState,
  fixedFeeUnavailableState,
} from '../../../../constants';

interface FixedFeeTermsListEmptyProps {
  hasFilter: boolean;
  disabled?: boolean;
}

export const FixedFeeTermsListEmpty: React.FC<FixedFeeTermsListEmptyProps> = ({
  hasFilter,
  disabled,
}) => {
  if (disabled) {
    return (
      <VStack py="stack.lg">
        <ErrorBoundary
          errorIconOrIllustration="WarningIllustration"
          errorTitle="Visualização indisponível"
          errorMessage={fixedFeeUnavailableState}
        />
      </VStack>
    );
  }

  if (hasFilter) {
    return (
      <VStack py="stack.lg">
        <ErrorBoundary
          errorIconOrIllustration="NotFoundIllustration"
          errorTitle="Nenhum termo localizado"
          errorMessage={fixedFeeTermsEmptyState}
        />
      </VStack>
    );
  }

  return (
    <VStack py="stack.lg">
      <ErrorBoundary
        errorIconOrIllustration="NotFoundIllustration"
        errorTitle="Nenhum cliente com Fee Fixo"
        errorMessage={fixedFeeTermsNoRequestsState}
      />
    </VStack>
  );
};
